module.exports = __webpack_public_path__ + "static/media/afterMidDay.2671fe3b.png";